import { data } from "jquery";
import moment from "moment";
import { func_cookie } from "./func_cookie";

export const func_validation = {
	
    // Null / Undefined

	isNotNull,
	isNull, 
	isNotUndefined,
	isUndefined, 
	isNotNullUndefined,
	isNullUndefined,
	
	// Number
	isNumber,
	isNumberValid,
	isNumberGreaterThanZero,
	isNumberWithinRange,
	isNumberOrStringValid,
	getNumberAfterRangeValidation,
	getIntAfterValidation,
	getFloatAfterValidation,
	getParsedFormattedFloat,
	getParsedFormattedInt,
	
    // String

    isString,
	isStringValid,
	isStringValidNumber,
	isStringEmpty,
	isStringNotEmpty,
	isStringTrimEmpty,
	isStringTrimNotEmpty,
	getTrimmedString,
	getStringLength,
	getStringTrimmedLength,
	getLowerCaseString,
	getUpperCaseString,
	getLowerCaseTrimmedString,
	getUpperCaseTrimmedString,
	isStringEqual_caseInsensitive,
	isStringEqual_caseSensitive,
	isStringInValue,
	getCharacterAtString,
	getSubstring,
	getSplitString,
	getFirstSplitString,
	getLowerCaseFirstSplitString,
	getUpperCaseFirstSplitString,
	getTruncatedString,
	truncateValueAtPosMatch,
	getStringUniqueId,
	convertCamelCaseToWords,
	getUserFriendlyTrueFalseDisplay,
	reformatNumberWithCommas,
	reformatNumberDecimalPlaces,


    // Object

	isObject,
	isObjectValid,
	isObjectEmpty,
	isObjectNotEmpty,
	getObjectLength,
	hasObjectProperty,
	getObjectPropertyValue,
	getObjectPropertyValue_stringTrimNotEmpty,
	getObjectPropertyValue_validNumber,
	getObjectPropertyValue_stringToDateTime,
	getObjectPropertyValueNotNullUndefined,
	cloneObject,
	isObjectComparisonEqual,
	isDeepObjectComparisonEqual,
	getObjectPropertyValueByDynamicPropName,
	deepCloneObject,
	combineObjects,
	getObjectPropertyValue_caseInsensitive,

	// Permission
	isUserAccessGranted,
	isUserAccessDenied,
	removePermissionFromList,

	// Array

	isArray,
	isArrayEmpty,
	isArrayNotEmpty,
	getArrayLength,
	isArrayLengthEqual,
	hasArrayValue,
	cloneArray,
	isComparisonOfBothArraysEqual,
	isComparisonOfBothArraysNotEqual,
	isDeepArrayComparisonEqual,
	isElementInArray,
	cloneArrayOfObject,
	deepCloneArray,
	pushElementIntoArray,
	filterNegatedElementFromArray,
	convertSimpleArrayToObjectArray,
	isElementsInArrayValid,
	getAtoZArray,
	convertArrayToDropdownArrayFormat,
	getDropdownLabel,
	removeArrayDuplicates,
	removeNonMatching,

	// Boolean

	isBoolean, 
	isBooleanTrue, 
	isBooleanFalse, 
	isBooleanNotNullUndefined,
	isBooleanTrueNotNullUndefined, 
	isBooleanFalseNotNullUndefined,

	// Function
	isFunction,
	getSelectorFunc,

	// JSON

	isJsonString,

	// Regex Evaluation

	testValAgainstRegex,
	findStringMatchAgainstRegex,
	replaceValAgainstRegex,

	// Regex Modifier

	setRegexModifer, 
	getRegexModifierCaseInsensitive,
	getRegexModifierGlobal,
	getRegexModifierMultiline,

	// Regex

	getRegexEmail,
	getRegexEmailCaseInsensitive,
	getRegexCompanyRegisNum,
	getRegexCompanyRegisNumCaseInsensitive,
	getRegexCompanyRegisNumAlphanumericFormat,
	getRegexCompanyRegisNumAlphanumericFormatCaseInsensitive,
	getRegexCompanyRegisNumDigitFormat,
	getRegexCompanyRegisNumDigitFormatCaseInsensitive,
	getRegexContainXChar,
	
	getRegexLowerCase,
	getRegexAnyLowerCase,
	getRegexLowerCaseGlobal,

	getRegexNotLowerCase,
	getRegexAnyNotLowerCase,
	getRegexNotLowerCaseGlobal,

	getRegexUpperCase,
	getRegexAnyUpperCase,
	getRegexUpperCaseGlobal,

	getRegexNotUpperCase,
	getRegexAnyNotUpperCase,
	getRegexNotUpperCaseGlobal,

	getRegexDigit,
	getRegexAnyDigit,
	getRegexDigitGlobal,

	getRegexNotDigit,
	getRegexAnyNotDigit,
	getRegexNotDigitGlobal,

	getRegexSpecialCase,
	getRegexAnySpecialCase,
	getRegexSpecialCaseGlobal,

	getRegexNotSpecialCase,
	getRegexAnyNotSpecialCase,
	getRegexNotSpecialCaseGlobal,
	
	getRegexMatchCurrencyDoublePrecision,
	getRegexMatchCurrencyDoublePrecisionCaseInsensitive,

	getRegexAnyHypenUnderscore,

	// Table

	isTableExisting,
	isTableRowNotEmpty,
	isTableColumnNotEmpty,
	getTableCellValue,
	getTableCellValue_string,
	getTableRow,
	getTableRowDepth,
	isTableRowIndexSubrow,
	getTableRowIndex,
	getTableRowOriginalValue,

	// Token
	isAccessTokenValid,
	isRefreshTokenValid,

	// Date

	isPastDate,
	getISODateFormat,
	isDateValid,

	// API
	getTotalCountFromHeader,
}

// General
export function isCompletelyEqual(val1, val2) {
	function isDeepCheckEqual(val1, val2) {
		if (isArray(val1) && isArray(val2)) {
			let isNonMatchFound = false;
			val1.map((item, idx) => {
				if (!isCompletelyEqual(item, val2.length > idx? val2[idx]:[])) {
					isNonMatchFound = true;
				}
			});
			return !isNonMatchFound;
		}
		else if (isObject(val1) && isObject(val2)) {
			let isNonMatchFound = false;
			for (let property in val1) {
				if (!(val1.hasOwnProperty(property) &&
					val2.hasOwnProperty(property) &&
					isCompletelyEqual(val1[property], val2[property]))) {
					isNonMatchFound = true;
				}
			}
			return !isNonMatchFound;
		}
		return false;
	}

	return val1 === val2 || isDeepCheckEqual(val1, val2);
}


/*
 * Null | Undefined
 */

export function isNotNull(val) {
	return (val !== null);
}

export function isNull(val) {
	return (val == null);
}

export function isNotUndefined(val) {
	return (typeof val !== "undefined");
}

export function isUndefined(val) {
	return (typeof val == "undefined");
}

export function isNotNullUndefined(val) {
	return (isNotNull(val) && isNotUndefined(val));
}

export function isNullUndefined(val) {
	return (isNull(val) || isUndefined(val));
}


/*
 * Number
 */

export function isNumber(val) {
	return (typeof val) === "number";
}

export function isNumberValid(val) {
	return isNumber(val) && isNotNullUndefined(val) && !isNaN(val);
}

export function isNumberGreaterThanZero(val) {
	return isNumberValid(val) && val > 0;
}

// Check is within range (both inclusive)
export function isNumberWithinRange(val, { min, max, equal }) {
	if (isNumberValid(val)) {
		if (isNumberValid(equal)) return (val == equal);
		else if (isNumberValid(min) && isNumberValid(max)) return (val >= min && val <= max);
		else if (isNumberValid(min)) return (val >= min);
		else if (isNumberValid(max)) return (val <= max);
	}
	return false;
}

export function isNumberOrStringValid(value) {
	return isNumberValid(value) || 
		(isStringTrimNotEmpty(value) && 
		(value.match(/^\d+\.?\d*/g) && value.match(/^\d+\.?\d*/g)[0].length === value.length) && 
		!isNaN(parseFloat(value)));
}

export function getNumberAfterRangeValidation(val, defaultVal, { min, max, equal }) {
	if (isNumberWithinRange(val, { min, max, equal })) return parseFloat(val);
	if (isNotNullUndefined(defaultVal)) return defaultVal;
	return undefined;
}

export function getIntAfterValidation(val, defaultVal) {
	if (isNumberValid(val)) return parseInt(val);
	if (isNotNullUndefined(defaultVal)) return defaultVal;
	return undefined;
}

export function getFloatAfterValidation(val, defaultVal) {
	if (isNumberValid(val)) return parseFloat(val);
	if (isNotNullUndefined(defaultVal)) return defaultVal;
	return undefined;
}

export function getParsedFormattedFloat(unparsedVal, defaultVal) {
	if (isStringTrimNotEmpty(unparsedVal)) {
		let formattedValue = unparsedVal.replace(/[^0-9\.]/g,"");
		return parseFloat(formattedValue);
	}
	else if (isNotNullUndefined(defaultVal))
		return defaultVal;
		
	return undefined;
}

export function getParsedFormattedInt(unparsedVal, defaultVal) {
	let formattedValue = getParsedFormattedFloat(unparsedVal, defaultVal);
	return parseInt(formattedValue);
}


/*
 * String
 */

export function isString(val) {
    return (typeof val) === "string";
}

export function isStringValid(val) {
	return (isNotNullUndefined(val) && isString(val));
}

export function isStringValidNumber(val) {
	return isStringValid(val) && (!isNaN(parseFloat(val)));
}

export function isStringEmpty(val) {
	return (isStringValid(val) && val == "");
}

export function isStringNotEmpty(val) {
	return (isStringValid(val) && val !== "");
}

export function isStringTrimEmpty(val) {
    return (isStringValid(val) && val.trim() == "");
}

export function isStringTrimNotEmpty(val) {
    return (isStringNotEmpty(val) && val.trim() !== "");
}

export function getTrimmedString(val, defaultValue) {
	if (isStringValid(val)) return val.trim();
	if (isNotNullUndefined(defaultValue)) return defaultValue;
	return undefined;
}

export function getStringLength(val) {
	if (isStringValid(val)) return val.length;
	return undefined;
}

export function getStringTrimmedLength(val) {
	if (isStringValid(val)) return getTrimmedString(val).length;
	return undefined;
}

export function getLowerCaseString(val) {
	if (isStringValid(val)) return val.toLowerCase();
	return undefined;
}

export function getUpperCaseString(val) {
	if (isStringValid(val)) return val.toUpperCase();
	return undefined;
}

export function getLowerCaseTrimmedString(val) {
	if (isStringValid(val)) {
		let tStr = getTrimmedString(val);
		return getLowerCaseString(tStr);
	}
	return undefined;
}

export function getUpperCaseTrimmedString(val) {
	if (isStringValid(val)) {
		let tStr = getTrimmedString(val);
		return getUpperCaseString(tStr);
	}
	return undefined;
}

export function isStringEqual_caseInsensitive(val1, val2) {
	if (isStringValid(val1) && isStringValid(val2)) {
		return (getLowerCaseTrimmedString(val1) === getLowerCaseTrimmedString(val2));
	}
	return false;
}

export function isStringEqual_caseSensitive(val1, val2) {
	if (isStringValid(val1) && isStringValid(val2)) {
		return (getTrimmedString(val1) === getTrimmedString(val2));
	}
	return false;
}

export function isStringInValue(val, stringToFind) {
	if (isStringValid(val) && isStringValid(stringToFind)) {
		return (~val.indexOf(stringToFind));
	}
	return false;
}

export function getCharacterAtString(val, idx) {
	if (isStringValid(val) && isNumberValid(idx)) return val.charAt(idx);
	return "";
}

export function getSubstring(val, start, end) {
	if (isStringValid(val) && (isNumberValid(start) || isNumberValid(end))) return val.substring(start, end);
	return "";
}

export function getSplitString(val, regex) {
	if (isStringValid(val) && isNotNullUndefined(regex)) return val.split(regex);
	return [];
}

export function getFirstSplitString(val, regex) {
	let splitStringArray = getSplitString(val, regex);
	if (isArrayNotEmpty(splitStringArray)) return splitStringArray[0];
	return "";
}

export function getLowerCaseFirstSplitString(val, regex) {
	let splitStringArray = getSplitString(getLowerCaseTrimmedString(val), regex);
	if (isArrayNotEmpty(splitStringArray)) return splitStringArray[0];
	return "";
}

export function getUpperCaseFirstSplitString(val, regex) {
	let splitStringArray = getSplitString(getUpperCaseTrimmedString(val), regex);
	if (isArrayNotEmpty(splitStringArray)) return splitStringArray[0];
	return "";
}

export function getTruncatedString(val, length) {
	return getSubstring(val, 0, length);
}

export function truncateValueAtPosMatch(val, match, idx) {
	let value_formatted = val.toString();
	let maxLength = getStringLength(val);
	let loopCycle = 1;

	if (isStringValid(value_formatted) && isStringValid(match) && 
		isNotNullUndefined(maxLength)) {

		while (isStringEqual_caseInsensitive(getCharacterAtString(value_formatted, idx), match)) {
			value_formatted = getSubstring(value_formatted, 0, idx)+getSubstring(value_formatted, idx+1);

			// (failsafe) if next loop exceeds number of characters in string, exit loop
			if (loopCycle >= maxLength) break;
			else loopCycle++;
		}
	}

	return value_formatted;
}

export function getStringUniqueId(id) {
	if (isStringTrimNotEmpty(id) ||
		isNumberValid(id)) {

		return "" + id + Math.floor(Math.random() * 1000000);
	}
	return "";
}

export function convertCamelCaseToWords(str) {
	if (isStringTrimNotEmpty(str)) {
		// Find upper cases
		let newString = "";
		for (let i = 0; i < str.length; i++) {
			let character = str.charAt(i);
			if (character.toUpperCase() == character) {
				newString += " " + character;
			}
			else newString += character;
		}
		return newString;
	}
	return undefined;
}

export function getUserFriendlyTrueFalseDisplay(boolean) {
	if (isBoolean(boolean))
		return boolean? "Yes": "No";
	else if (isStringEqual_caseInsensitive(boolean, "true") ||
		isStringEqual_caseInsensitive(boolean, "false"))
		return isStringEqual_caseInsensitive(boolean, "true")? "Yes":"No";
	return boolean;
}

export function reformatNumberWithCommas(value) {
	return new Intl.NumberFormat().format(value);
}

export function reformatNumberDecimalPlaces(value) {
	return new Intl.NumberFormat("en", { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(value);
}

/*
 * Object
 */

export function isObject(obj) {
	return (typeof obj === "object");
}

export function isObjectValid(obj) {
	return (isNotNullUndefined(obj) && isObject(obj));
}

export function isObjectEmpty(obj) {
	return (isObjectValid(obj) && Object.keys(obj).length == 0);
}

export function isObjectNotEmpty(obj) {
	return (isObjectValid(obj) && Object.keys(obj).length > 0);
}

export function getObjectLength(obj) {
	if (isObjectValid(obj)) return Object.keys(obj).length;
	return undefined;
}

export function hasObjectProperty(obj, propName) {
	return (isObjectNotEmpty(obj) && isStringTrimNotEmpty(propName) && 
			isNotNullUndefined(obj[propName]));
}

export function getObjectPropertyValue(obj, propName, defaultVal) {
	if (hasObjectProperty(obj, propName)) return obj[propName];
	if (isNotNullUndefined(defaultVal)) return defaultVal;
	return undefined;
}

export function getObjectPropertyValue_stringTrimNotEmpty(obj, propName, defaultVal) {
	let propertyValue = getObjectPropertyValue(obj, propName, defaultVal);
	let propertyValue_validated = isStringTrimNotEmpty(propertyValue)? propertyValue: defaultVal;
	return propertyValue_validated;
}

export function getObjectPropertyValue_validNumber(obj, propName, defaultVal) {
	let propertyValue = getObjectPropertyValue(obj, propName, defaultVal);
	let propertyValue_validated = propertyValue;
	if (isStringValidNumber(propertyValue) || isNumberValid(propertyValue))
		propertyValue_validated = parseFloat(propertyValue);

	return propertyValue_validated;
}

export function getObjectPropertyValue_stringToDateTime(obj, propName, defaultVal) {
	let propertyValue = getObjectPropertyValue(obj, propName, defaultVal);
	let propertyValue_validated = (isStringTrimNotEmpty(propertyValue))? new Date(propertyValue): new Date();
	return propertyValue_validated;
}

export function getObjectPropertyValueNotNullUndefined(obj, propName, defaultVal) {
	if (hasObjectProperty(obj, propName)) {
		if (isNullUndefined(obj[propName]) && 
			isNotNullUndefined(defaultVal)) {
			return defaultVal;
		}
		else return obj[propName];
	}
	if (isNotNullUndefined(defaultVal)) return defaultVal;
	return undefined;
}

export function cloneObject(obj) {
	if (isObjectValid(obj)) return Object.assign({}, obj);
	return {};
}

export function isObjectComparisonEqual(obj1, obj2) {
	if (!isObjectValid(obj1) || !isObjectValid(obj2)) return false;
	else if ((!isObjectEmpty(obj1) && isObjectEmpty(obj2)) || 
		(isObjectEmpty(obj1) && !isObjectEmpty(obj2))) {
		return false;
	}
	else if (isObjectNotEmpty(obj1) &&
		isObjectNotEmpty(obj2)) {

		for (let key in obj1) {
			if (obj1.hasOwnProperty(key) &&
				obj2.hasOwnProperty(key)) {
				if (isObjectValid(obj1[key])) {
					if (!isObjectComparisonEqual(obj1[key], obj2[key])) return false;
				}
				else if (obj1[key] !== obj2[key]) return false;
			}
			else return false;
		}
	}

	return true;
}

export function isDeepObjectComparisonEqual(obj1, obj2) {
	// iterate the object
	if (isObject(obj1) && isObject(obj2)) {
		let isNonMatchFound = false;

		if (isObjectNotEmpty(obj1) && isObjectNotEmpty(obj2) &&
			getObjectLength(obj1) == getObjectLength(obj2)) {

			for (let property in obj1) {
				let val1 = obj1?.[property];
				let val2 = obj2?.[property];
	
				if (isArray(val1) && isArray(val2)) {
					isNonMatchFound = !isDeepArrayComparisonEqual(val1, val2);
					if (isNonMatchFound) break;
				}
				else if (isObject(val1) && isObject(val2)) {
					isNonMatchFound = !isDeepObjectComparisonEqual(val1, val2);
					if (isNonMatchFound) break;
				}
				else if (val1 !== val2) {
					isNonMatchFound = true; break;
				}
			}
		}
		else if (getObjectLength(obj1) != getObjectLength(obj2)) 
			isNonMatchFound = true;

		return !isNonMatchFound;
	}
	return false;
}

export function getObjectPropertyValueByDynamicPropName(obj, dynamicPropName, defaultVal) {
	return getObjectPropertyValue(
		obj, 
		getObjectPropertyValue(obj, dynamicPropName), 
		defaultVal
	);
}

export function deepCloneObject(obj) {
	if (isObjectNotEmpty(obj)) {

        let newObj = {};
		for (let key in obj) {

			if (obj.hasOwnProperty(key)) {
                if (isArray(obj[key])) {

					newObj[key] = deepCloneArray(obj[key]);
				}
                else if (isObject(obj[key]) &&
                         isNotNullUndefined(obj[key])) {

					newObj[key] = deepCloneObject(obj[key]);
				}
				else newObj[key] = obj[key];
			}
        }
        return newObj;
	}
	return obj;
}

export function combineObjects(arryaOfObjects) {
	if (isArrayNotEmpty(arryaOfObjects)) {
		let concatObj = {};
		arryaOfObjects.map((obj) => {
			concatObj = Object.assign({}, deepCloneObject(concatObj), deepCloneObject(obj));
		});

		return concatObj;
	}
	return undefined;	
}

export function getObjectPropertyValue_caseInsensitive(obj, selectedProperty) {
	if (isStringTrimNotEmpty(selectedProperty)) {
		for (const property in obj) {
			if (obj.hasOwnProperty(property)) {
				if (isStringEqual_caseInsensitive(selectedProperty, property)) {
					return obj[property];
				}
			}
		}
	}
	return undefined;
}


/*
 * Permission
 */

export function isUserAccessGranted(props, permissionName) {
	let userPermissions = getObjectPropertyValue(props, "userPermissions", {});
	return getObjectPropertyValue(userPermissions, permissionName, false);
}

export function isUserAccessDenied(props, permissionName) {
	return !isUserAccessGranted(props, permissionName);
}

export function removePermissionFromList(permissionList, toBeRemovedList) {
	let permissionList_new = deepCloneArray(permissionList);
	let isMatchFound = false;
	toBeRemovedList.map((fullPermissionName) => {
		if (isStringTrimNotEmpty(fullPermissionName)) {
			let permissionTypeList = fullPermissionName.split("_");

			if (getArrayLength(permissionTypeList, 0) === 3) {
				let role = permissionTypeList[0];
				let userGroup = permissionTypeList[1];
				let permission = permissionTypeList[2];

				// Find matching role
				for (let i = 0; i < permissionList_new.length; i++) {
					if (func_validation.isStringEqual_caseSensitive(permissionList_new[i].Role, role)) {
						// Find matching user group
						let userGroupList = permissionList_new[i].UserGroupPermissionList;

						for (let j = 0; j < userGroupList.length; j++) {
							if (func_validation.isStringEqual_caseSensitive(userGroupList[j].UserGroupPermission, userGroup)) {
								// Find matching permission
								let permissionList = userGroupList[j].PermissionList;

								for (let z = 0; z < permissionList.length; z++) {
									if (func_validation.isStringEqual_caseSensitive(permissionList[z].Permission, permission)) {
										permissionList.splice(z, 1);
										isMatchFound = true;
										break;
									}
								}

								// Is empty after deletion?
								if (isArrayEmpty(permissionList)) {
									userGroupList.splice(j, 1);
								}

								if (isMatchFound) break;
							}
						}

						// Is empty after deletion?
						if (isArrayEmpty(userGroupList)) {
							permissionList_new.splice(i, 1);
						}

						if (isMatchFound) break;
					}
				}
			}
		}
	});

	return permissionList_new;
}


/*
 * Array
 */

export function isArray(val) {
	return Array.isArray(val);
}

export function isArrayEmpty(array) {
	return (isArray(array) && array.length == 0);
}

export function isArrayNotEmpty(array) {
	return (isArray(array) && array.length > 0);
}

export function getArrayLength(array, defaultValue) {
	if (isArray(array)) return array.length;
	if (isNumberValid(defaultValue)) return defaultValue;
	return undefined;
}

export function isArrayLengthEqual(array, equalValue) {
	let arrayLength = getArrayLength(array);

	if (!isNumberValid(arrayLength) || 
		!isNumberValid(equalValue)) 
		return undefined;

	return arrayLength == equalValue;
}

export function hasArrayValue(array, value) {
	return (isArrayNotEmpty(array) && array.includes(value));
}

export function cloneArray(array) {
	if (isArray(array)) return array.slice();
	return [];
}

export function isComparisonOfBothArraysEqual(array1, array2) {
	return JSON.stringify(array1) == JSON.stringify(array2);
}

export function isComparisonOfBothArraysNotEqual(array1, array2) {
	return JSON.stringify(array1) != JSON.stringify(array2);
}

export function isDeepArrayComparisonEqual(arr1, arr2) {
	// iterate the array
	if (isArray(arr1) && isArray(arr2)) {
		let isNonMatchFound = false;

		if (isArrayNotEmpty(arr1) && isArrayNotEmpty(arr2) &&
			getArrayLength(arr1) == getArrayLength(arr2)) {

			for (let i = 0; i < arr1.length; i++) {
				let val1 = arr1[i];
				let val2 = arr2[i];
	
				if (isArray(val1) && isArray(val2)) {
					isNonMatchFound = !isDeepArrayComparisonEqual(val1, val2);
				}
				else if (isObject(val1) && isObject(val2)) {
					isNonMatchFound = !isDeepObjectComparisonEqual(val1, val2);
				}
				else if (val1 !== val2) {
					isNonMatchFound = true;
				}
			}
		}
		else if (getArrayLength(arr1) != getArrayLength(arr2)) {
			isNonMatchFound = true;
		}

		return !isNonMatchFound;
	}
	return false;
}

export function isElementInArray(val, elementToFind) {
	if (isArrayNotEmpty(val) && isNotNullUndefined(elementToFind)) {
		return (~val.indexOf(elementToFind));
	}
	return false;
}

export function cloneArrayOfObject(val) {
	let array_new = [];

	if (isArray(val)) {
		val.map((valEntry)=>{ array_new.push(cloneObject(valEntry)); });
	}

	return array_new;
}

export function deepCloneArray(array) {
	if (isArrayNotEmpty(array)) {

		let newArray = array.map((element) => {
			if (isArray(element)) {
				return deepCloneArray(element);
			}
			else if (isObject(element) &&
                     isNotNullUndefined(element)) {
				return deepCloneObject(element);
			}
			else return element;
		});

        return newArray;
	}
	return [];
}

export function pushElementIntoArray(arr, ele) {
	let arr_new = cloneArray(arr);
	
	if (isNotNullUndefined(ele)) arr_new.push(ele);

	return arr_new;
}

export function filterNegatedElementFromArray(arr) {
	if (isArrayNotEmpty(arr)) {
		return arr.filter((val)=>{ return (val); });
	}
	return [];
}

export function convertSimpleArrayToObjectArray(arr, propName) {
	let arr_new = [];

	if (isArrayNotEmpty(arr) && 
		isStringTrimNotEmpty(propName)) {
		
		arr.map((ele)=>{
			arr_new.push({ [propName]: ele });
		});
	}

	return arr_new;
}

export function isElementsInArrayValid(arr, func_validateEle) {
	let isValid = true;

	if (isArray(arr) && 
		isFunction(func_validateEle)) {
		arr.some((ele)=>{

			// End loop if element is not valid
			if (!func_validateEle(ele)) {
				isValid = false;
				return true;
			}
		});
	}

	return isValid;
}

export function getAtoZArray(isLowerCase) {
	if (isBooleanTrueNotNullUndefined(isLowerCase)) {
		return ["a","b","c","d","e","f","g","h","i","j","k","l","m","n","o","p","q","r","s","t","u","v","w","x","y","z"];
	}
	return ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"];
}

export function convertArrayToDropdownArrayFormat(array) {
	let newArray = [];
	if (isArrayNotEmpty(array)) {
		newArray = array.map((value) => {
			let value_formatted = isStringTrimNotEmpty(value) || isNumberValid(value)? value:"";

			return {
				label: value_formatted,
				value: value_formatted,
			};
		});
	}
	return newArray;
}

export function removeNonMatching(originalArray, regex) {
	let newArray = cloneArray(originalArray);
    for (let j = 0; j < newArray.length; j++) {
        if (!(regex.test(newArray[j]))) {
            newArray.splice(j, 1);
			j--;
		}
    }
    return newArray;
}

export function removeArrayDuplicates(array, customExclusion) {
	let newArray = [];
	array.map((value) => {
		if (newArray.indexOf(value) == -1) {
			if (isArrayNotEmpty(customExclusion)) {
				if (customExclusion.indexOf(value) == -1) {
					newArray.push(value);
				}
			}
			else {
				newArray.push(value);
			}
		}
	});

	return newArray;
}

export function getDropdownLabel(options, value) {
	if (isArrayNotEmpty(options)) {
		for (let i = 0; i < options.length; i++) {
			let label = getObjectPropertyValue(options[i], "label");
			let optionValue = getObjectPropertyValue(options[i], "value");

			if (isStringEqual_caseSensitive(optionValue, value)) {
				return label;
			}
		}
	}
	return "";
}


/*
 * Boolean
 */

export function isBoolean(value) {
	return (typeof value) == 'boolean';
}

export function isBooleanTrue(value) {
	return (isBoolean(value)) && (value == true);
}

export function isBooleanFalse(value) {
	return (isBoolean(value)) && (value == false);
}

export function isBooleanNotNullUndefined(value) {
	return isNotNullUndefined(value) && isBoolean(value);
}

export function isBooleanTrueNotNullUndefined(value) {
	return isNotNullUndefined(value) && isBooleanTrue(value);
}

export function isBooleanFalseNotNullUndefined(value) {
	return isNotNullUndefined(value) && isBooleanFalse(value);
}


/*
 * Function
 */

export function isFunction(value) {
	return (typeof value) == 'function';
}

export function getSelectorFunc(reducerName) {
    return state => getObjectPropertyValue(state, reducerName);
}


/*
 * JSON
 */

export function isJsonString(json) {
    try { JSON.parse(json.toString()); }
    catch (e) { return false; }
    return true;
}


/*
 * Regex Evaluation
 */

export function testValAgainstRegex(val, regex) {
	if (isNotNullUndefined(val) && 
		isNotNullUndefined(regex)) {
		return regex.test(val);
	} 
	return false;
}

export function findStringMatchAgainstRegex(val, regex) {
	if (isStringValid(val) && 
		isNotNullUndefined(regex)) {
		return val.match(regex);	
	}
	return undefined;
}

export function replaceValAgainstRegex(val, regex, replaceStr) {
	if (isStringValid(val) && 
		isNotNullUndefined(regex)) {
		return val.replace(regex, replaceStr);	
	}
	return "";
}


/*
 * Regex Modifier
 */

export function setRegexModifer(regex, modifier) {
	if (isNotNullUndefined(regex) && 
		isStringNotEmpty(modifier)) {
		return new RegExp(regex, modifier);
	}
	return undefined;
}

export function getRegexModifierCaseInsensitive() {
	return "i";
}

export function getRegexModifierGlobal() {
	return "g";
}

export function getRegexModifierMultiline() {
	return "m";
}


/* Regex
 * (Syntax): /pattern/modifiers
 * (Modifiers): 
 * 		- i : case insensitive
 * 		- g : perform global match (find all matches rather than stopping after first match)
 * 		- m : multiline matching
 */

// Regex - Email

export function getRegexEmail() {
	return /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/;
}

export function getRegexEmailCaseInsensitive() {
	return setRegexModifer(getRegexEmail(), getRegexModifierCaseInsensitive());
}

// Regex - Company Regis Num

// Condition:
// - At least 3 digits
// - Up to 12 Alphanumeric characters
export function getRegexCompanyRegisNum() {
	return /(?=(.*\d){3})^.*$/;
	// return /(?=(.*\d){3})^[a-zA-Z0-9_-]{0,12}$/;
}

export function getRegexCompanyRegisNumCaseInsensitive() {
	return setRegexModifer(getRegexCompanyRegisNum(), getRegexModifierCaseInsensitive());
}

// Condition:
// - Up to 12 Alphanumeric Characters
export function getRegexCompanyRegisNumAlphanumericFormat() {
	return /^[a-zA-Z0-9_-]{0,12}$/;
}

export function getRegexCompanyRegisNumAlphanumericFormatCaseInsensitive() {
	return setRegexModifer(getRegexCompanyRegisNumAlphanumericFormat(), getRegexModifierCaseInsensitive());
}

// Condition:
// - 12 digit characters
export function getRegexCompanyRegisNumDigitFormat() {
	return /^\d{12}$/;
}

export function getRegexCompanyRegisNumDigitFormatCaseInsensitive() {
	return setRegexModifer(getRegexCompanyRegisNumDigitFormat(), getRegexModifierCaseInsensitive());
}

// Regex - Contain X Char

export function getRegexContainXChar(xTimes) {
	if (isNumberValid(xTimes)) return new RegExp("^(?=.{"+xTimes+",})");
	return undefined;
}

// Regex - Lower Case

export function getRegexLowerCase() {
	return /^[a-z]/;
}

export function getRegexAnyLowerCase() {
	return /^(?=.*[a-z])/;
}

export function getRegexLowerCaseGlobal() {
	return setRegexModifer(getRegexLowerCase(), getRegexModifierGlobal());
}

// Regex - NOT Lower Case

export function getRegexNotLowerCase() {
	return /^[^a-z]/;
}

export function getRegexAnyNotLowerCase() {
	return /^(?=.*[^a-z])/;
}

export function getRegexNotLowerCaseGlobal() {
	return setRegexModifer(getRegexNotLowerCase(), getRegexModifierGlobal());
}

// Regex - Upper Case

export function getRegexUpperCase() {
	return /^[A-Z]/;
}

export function getRegexAnyUpperCase() {
	return /^(?=.*[A-Z])/;
}

export function getRegexUpperCaseGlobal() {
	return setRegexModifer(getRegexUpperCase(), getRegexModifierGlobal());
}

// Regex - NOT Upper Case

export function getRegexNotUpperCase() {
	return /^[^A-Z]/;
}

export function getRegexAnyNotUpperCase() {
	return /^(?=.*[^A-Z])/;
}

export function getRegexNotUpperCaseGlobal() {
	return setRegexModifer(getRegexNotUpperCase(), getRegexModifierGlobal());
}

// Regex - Digit

export function getRegexDigit() {
	return /^[0-9]/;
}

export function getRegexAnyDigit() {
	return /^(?=.*[0-9])/;
}

export function getRegexDigitGlobal() {
	return setRegexModifer(getRegexDigit(), getRegexModifierGlobal());
}

// Regex - NOT Digit

export function getRegexNotDigit() {
	return /^[^0-9]/;
}

export function getRegexAnyNotDigit() {
	return /^(?=.*[^0-9])/;
}

export function getRegexNotDigitGlobal() {
	return setRegexModifer(getRegexNotDigit(), getRegexModifierGlobal());
}

// Regex - Special Case

export function getRegexSpecialCase() {
	// return /^[!@#$%^&*]/;
	return /^[^a-zA-Z0-9]/;
}

export function getRegexAnySpecialCase() {
	// return /^(?=.*[!@#$%^&*])/;
	return /^(?=.*[^a-zA-Z0-9])/;
}

export function getRegexSpecialCaseGlobal() {
	return setRegexModifer(getRegexSpecialCase(), getRegexModifierGlobal());
}

// Regex - NOT Special Case

export function getRegexNotSpecialCase() {
	// return /^[^!@#$%^&*]/;
	return /^[a-zA-Z0-9]/;
}

export function getRegexAnyNotSpecialCase() {
	// return /^(?=.*[^!@#$%^&*])/;
	return /^(?=.*[a-zA-Z0-9])/;
}

export function getRegexNotSpecialCaseGlobal() {
	return setRegexModifer(getRegexNotSpecialCase(), getRegexModifierGlobal());
}

// Regex - Currency

export function getRegexMatchCurrencyDoublePrecision() {
	return /^(\d)*(\.\d{0,2})?$/;
}

export function getRegexMatchCurrencyDoublePrecisionCaseInsensitive() {
	return setRegexModifer(getRegexMatchCurrencyDoublePrecision(), getRegexModifierCaseInsensitive());
}

// Regex 
export function getRegexAnyHypenUnderscore() {
	return /[_-]+/;
}

/*
 * Table
*/

export function isTableExisting(tableId) {
	let tableEle = document.getElementById(tableId);
	return isNotNullUndefined(tableEle);
}

export function isTableRowNotEmpty(tableId) {
	let tableEle = document.getElementById(tableId);

	if (isTableExisting(tableId)) {
		let rowsArray = tableEle.rows;
		return isObjectNotEmpty(rowsArray);
	}
}

export function isTableColumnNotEmpty(tableId) {
	if (isTableRowNotEmpty(tableId)) {
		let tableEle = document.getElementById(tableId);
		let columns = [...tableEle.rows[0].cells];

		if (func_validation.isArrayNotEmpty(columns))
			return true;
	}
	return false;
}

export function getTableCellValue(props) {
	let cell = getObjectPropertyValue(props, "cell");
	return getObjectPropertyValue(cell, "value");
}

export function getTableCellValue_string(props, defaultVal) {
	let value = getTableCellValue(props);
	let value_formatted = isStringTrimNotEmpty(value)? value: 
		isNotNullUndefined(defaultVal)? defaultVal: "-";
	return value_formatted;
}

export function getTableRow(props) {
	return getObjectPropertyValue(props, "row");
}

export function getTableRowDepth(props, defaultVal) {
	return getObjectPropertyValue(getTableRow(props), "depth", defaultVal);
}

export function isTableRowIndexSubrow(props, defaultVal) {
	let depth = getTableRowDepth(props, defaultVal);
	return (depth > 0);
}

export function getTableRowIndex(props, defaultVal) {
	return getObjectPropertyValue(getTableRow(props), "index", defaultVal);
}

export function getTableRowOriginalValue(props, defaultVal) {
	return getObjectPropertyValue(getTableRow(props), "original", defaultVal);
}

/*
 * Token
*/

export function isAccessTokenValid(cookieName) {
	let accessToken = func_cookie.getCookieValue(cookieName);
	return isStringTrimNotEmpty(accessToken);
}

export function isRefreshTokenValid(cookieName) {
	let refresh_token = func_cookie.getCookieValue(cookieName);
	return isStringTrimNotEmpty(refresh_token);
}

/*
 * Date
*/

export function isPastDate(date) {
	let currentDate = new Date();
	let date_formatted = new Date(date);
	return (date_formatted.getTime() < currentDate.getTime());
}

export function getISODateFormat(date) {
	try {
		let date_formatted = new Date(date);
		return date_formatted.toISOString();
	} catch(err) {
		return "";
	}
}

export function isDateValid(date) {
	return isNotNullUndefined(date) && moment(date).isValid() && !isNumberOrStringValid(date);
}

export function convertToAPIDateFormat(date) {
	return isDateValid(date) && moment(date).utc(true).format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]");
}

// DOM Manipulation
export function getWindowHeight() {
	let body = document.body,
    html = document.documentElement;

	let height = Math.max( body.scrollHeight, body.offsetHeight, 
                       html.clientHeight, html.scrollHeight, html.offsetHeight );
	return height;
}

/*
	API
*/

export function getTotalCountFromHeader(header) {
	let totalRecords = getObjectPropertyValue_caseInsensitive(header, "x-total-count");
	if (isNumberOrStringValid(totalRecords))
    	return parseInt(totalRecords);
	return undefined;
}